import { TicketLineDTO, NamedDiscountType, Res, SoldProductType } from 'core/api';
import * as SalesStore from '../SalesStore';
import setTicketLineDiscountScreen from './setTicketLineDiscountScreen';
import { RestaurantFacade } from 'pos/facades';
import { Command } from 'pos/common';
import { Result } from 'core/infrastructure';
import { Message } from 'core/ui-next/modal';

declare global {
	interface CommandType {
		setTicketLineDiscount: (line: TicketLineDTO) => Promise<Result>
	}
}

Command.register('setTicketLineDiscount', 'NO_PRECONDITION', async (line: TicketLineDTO): Promise<Result> => {
	if (line.Type === SoldProductType.MenuItem) {
		await Message.show(Res.Msg.MSG_CANNOT_ESTABLISH_DISCOUNTS_IN_MENU_ITEM_LINE());
		return Result.error();
	}

	const ticket = SalesStore.getTicket();
	const namedDiscounts = await RestaurantFacade.getNamedDiscountsByUser(ticket.Id, NamedDiscountType.Line);

	const selected = namedDiscounts.find(x => x.Id === line.AppliedDiscountId) || null;

	// Los descuentos con nombre y el descuento manual se muestran en la misma pantalla, en pestañas. Si la línea no
	// tiene descuentos con nombre no se le pasa ninguno y la pantalla sólo permite el descuento manual.
	if (namedDiscounts.length === 0)
		return setTicketLineDiscountScreen(line);
	else
		return setTicketLineDiscountScreen(line, namedDiscounts, selected);
});
